import React from 'react'
import RightSide from '../components/common/rightSide';
import ResearchEthics from '../components/other/researchEthics';


const ResearchEthicsPage = () => {
    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='row'>
                    {/* <div className='col-md-4'>
                        <RightSide />
                    </div> */}
                    <div className='col-md-12'>
                        <ResearchEthics />
                    </div>

                </div>
            </div>
        </>
    )
}


export default ResearchEthicsPage;